function sanitize(context) {
  // Remove all entries with null/undefined values.
  Object.entries(context).forEach(([key, value]) => {
    if (value === null || value === undefined) {
      delete context[key];
    }
  });
}

export default class SuperProperty {
  constructor() {
    this.userKey = null;
    this.eventKey = null;
    this.firstName = null;
    this.lastName = null;
    this.email = null;
    Object.preventExtensions(this);
  }

  setUserKey(userKey) {
    this.userKey = userKey;
    return this;
  }

  setUserName(firstName, lastName) {
    this.firstName = firstName;
    this.lastName = lastName;
    return this;
  }

  setUserEmail(email) {
    this.email = email;
    return this;
  }

  setEventKey(eventKey) {
    this.eventKey = eventKey;
    return this;
  }

  build() {
    sanitize(this);
    return Object.freeze(this);
  }
}
